import React from "react";
import { MenuItem, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { i18n } from "../../translate/i18n";

export const WEEKDAYS = [
  { weekdayEn: "monday", weekday: "Lunes" },
  { weekdayEn: "tuesday", weekday: "Martes" },
  { weekdayEn: "wednesday", weekday: "Miercoles" },
  { weekdayEn: "thursday", weekday: "Jueves" },
  { weekdayEn: "friday", weekday: "Viernes" },
  { weekdayEn: "saturday", weekday: "Sábado" },
  { weekdayEn: "sunday", weekday: "Domingo" },
];

const STATUS_TIMES = {
  hours: { startTime: "08:00", endTime: "17:00" },
  closed: { startTime: "00:00", endTime: "00:00" },
  allDay: { startTime: "00:00", endTime: "23:59" },
};

const t = (key) => i18n.t(`settings.attention.hours.${key}`);

export const toWeek = (schedules) =>
  WEEKDAYS.map(({ weekdayEn, weekday }) => {
    const day = (Array.isArray(schedules) ? schedules : []).find((item) => item?.weekdayEn === weekdayEn);
    return { weekdayEn, weekday, startTime: day?.startTime || "", endTime: day?.endTime || "" };
  });

export const dayStatus = (day) => {
  if (!day.startTime && !day.endTime) return "allDay";
  if (day.startTime === "00:00" && day.endTime === "00:00") return "closed";
  if (day.startTime === "00:00" && day.endTime === "23:59") return "allDay";
  return "hours";
};

export const dayHasError = (day) =>
  dayStatus(day) === "hours" && (!day.startTime || !day.endTime || day.startTime >= day.endTime);

export const weekHasErrors = (week) => week.some(dayHasError);

export const weekIsRestricted = (week) => week.some((day) => dayStatus(day) !== "allDay");

const useStyles = makeStyles()(() => ({
  dayCell: {
    width: 120,
    fontWeight: 600,
  },
  status: {
    width: 150,
  },
  time: {
    width: 130,
  },
}));

const WeeklyScheduleTable = ({ value, onChange, disabled = false }) => {
  const { classes } = useStyles();
  const week = toWeek(value);

  const updateDay = (weekdayEn, patch) =>
    onChange(week.map((day) => (day.weekdayEn === weekdayEn ? { ...day, ...patch } : day)));

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>{t("day")}</TableCell>
          <TableCell>{t("status.title")}</TableCell>
          <TableCell>{t("from")}</TableCell>
          <TableCell>{t("to")}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {week.map((day) => {
          const status = dayStatus(day);
          const editable = !disabled && status === "hours";
          const error = dayHasError(day);
          return (
            <TableRow key={day.weekdayEn}>
              <TableCell className={classes.dayCell}>{t(`days.${day.weekdayEn}`)}</TableCell>
              <TableCell>
                <TextField
                  select
                  size="small"
                  className={classes.status}
                  value={status}
                  disabled={disabled}
                  onChange={(e) => updateDay(day.weekdayEn, STATUS_TIMES[e.target.value])}
                >
                  {Object.keys(STATUS_TIMES).map((key) => (
                    <MenuItem key={key} value={key}>
                      {t(`status.${key}`)}
                    </MenuItem>
                  ))}
                </TextField>
              </TableCell>
              <TableCell>
                <TextField
                  type="time"
                  size="small"
                  className={classes.time}
                  value={status === "hours" ? day.startTime : ""}
                  disabled={!editable}
                  error={error}
                  onChange={(e) => updateDay(day.weekdayEn, { startTime: e.target.value })}
                />
              </TableCell>
              <TableCell>
                <TextField
                  type="time"
                  size="small"
                  className={classes.time}
                  value={status === "hours" ? day.endTime : ""}
                  disabled={!editable}
                  error={error}
                  onChange={(e) => updateDay(day.weekdayEn, { endTime: e.target.value })}
                />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default WeeklyScheduleTable;
